import styled, { DefaultTheme } from 'styled-components';

import { PrimitiveStatus } from '../../../../models/common-payments';
interface StatusProps {
	readonly type: PrimitiveStatus;
	readonly borderFull?: boolean;
}

const getColor = (type: PrimitiveStatus, theme: DefaultTheme, size?: string) => {
	switch (type) {
		case 'success':
			return {
				bg: theme.colors.principal['light-alamak'],
				color: size === 'sm' ? theme.colors.principal.vanth : theme.colors.principal.orion,
				border: theme.colors.principal.alamak,
			};
		case 'pending':
			return {
				bg: theme.colors.extra.saturn_100,
				color: theme.colors.principal.orion,
				border: theme.colors.extra.saturn_500,
			};
		case 'error':
			return {
				bg: '#FDEFEF',
				color: theme.colors.principal.orion,
				border: '#FF7576',
			};
		case 'expired':
			return {
				bg: theme.colors.principal.ceres,
				color: theme.colors.principal.orion,
				border: theme.colors.extra.space_600,
			};
		default:
			return {
				bg: theme.colors.principal.ceres,
				color: theme.colors.principal.vanth,
				border: theme.colors.extra.space_600,
			};
	}
};

export const StatusContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
	gap: 4px;
	justify-content: flex-start;
	width: 100%;
`;

export const Label = styled.span<StatusProps>`
	align-items: flex-end;
	color: ${({ type, theme }) => getColor(type, theme).color};
	display: flex;
	font-weight: 400;
	line-height: 12px;
	vertical-align: baseline;
`;
